import SellRequestForm from "@/components/forms/SellRequestForm";

const SellProductForm = () => {
    return <SellRequestForm />;
};

export default SellProductForm;